import moment from 'moment';

export function toDateOnlyString(date?: Date) {
  if (!date) return null;

  return moment(date).format('yyyy-MM-DD');
}
